import React, { useState } from "react";
import * as Icon from "react-feather";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";
import { Col, Row, Card, CardBody, Container } from "reactstrap";
import { Link } from "react-router-dom";
import DetailsModal from "./DetailsModal";

import Image1 from "../assets/images/solution/bg.jpg";
import Image2 from "../assets/images/solution/bg2.jpg";
import Image3 from "../assets/images/solution/bg3.jpg";
import Image4 from "../assets/images/solution/bg4.jpg";
import Image5 from "../assets/images/solution/bg5.jpg";
import Image6 from "../assets/images/solution/bg6.jpg";

export default function AgencyProject() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({});

  const images = [Image1, Image2, Image3, Image4, Image5, Image6];

  // Detailed service data for the 5 solutions
  const serviceData = {
    "06": {
      title: "HCare360 Data Platform",
      thumb: Image6,
      intro:
        "Unlock the Full Power of Your Data – Securely, Intelligently, and at Scale. In today's healthcare and life sciences ecosystem, data is everywhere — unstructured, dynamic, and dispersed across silos. Harnessing its full potential for AI and advanced analytics requires a modern, compliant, and efficient data foundation.",
      description:
        "HCare360 is our cloud-native, next-generation data platform, purpose-built to unify, standardize, and operationalize your enterprise data landscape. Designed with speed, security, and scalability in mind, HCare360 enables seamless data ingestion, transformation, governance, and insight generation — all while maintaining full compliance with regulatory and legal requirements.",
      features: [
        {
          title: "Secure & Compliant Architecture",
          details: [
            "Built to meet stringent data privacy and compliance standards (HIPAA, GDPR, etc.)",
            "Enterprise-grade encryption, access control, and audit readiness",
          ],
        },
        {
          title: "Intelligent Data Ingestion & Storage",
          details: [
            "Integrate structured and unstructured data across departments, vendors, and systems",
            "Flexible ingestion layer and scalable cloud storage infrastructure",
          ],
        },
        {
          title: "ML-Powered Data Quality Management",
          details: [
            "Embedded machine learning algorithms to detect, score, and correct data anomalies automatically",
            "Improving data trust and usability",
            "Automated data quality and governance processes",
          ],
        },
        {
          title: "Agent-Based Workflow Orchestration",
          details: [
            "Configure intelligent, low-code data workflows",
            "Automate transformations, validations, and event-driven triggers",
          ],
        },
        {
          title: "Built-in AI/ML Toolbox",
          details: [
            "Accelerate model development with ready-to-use pipelines",
            "Feature stores, training environments, and integration to large language models (LLMs)",
          ],
        },
        {
          title: "Self-Service Analytics & Visualization",
          details: [
            "Empower business users and analysts with intuitive dashboards",
            "Embedded analytics and no-code data exploration tools",
            "Enable self-service and transparency in enterprise data interaction",
          ],
        },
        {
          title: "Unified Data Governance & Metadata Management",
          details: [
            "Enforce consistent data policies, lineage tracking, and cataloging",
            "Support secure, scalable data operations",
          ],
        },
        {
          title: "Why HCare360?",
          details: [
            "Reduce time-to-model from weeks to days",
            "Streamline data access and reuse across teams",
            "Automate and scale data quality and governance",
            "Simplify AI/ML model deployment and insight delivery",
            "Enable self-service and transparency in enterprise data interaction",
            "HCare360 is more than a platform — it's a catalyst for intelligent healthcare innovation",
            "Request a demo or explore how HCare360 fits into your digital transformation journey.",
          ],
        },
      ],
    },
    "07": {
      title: "IT Cost Optimization",
      thumb: Image1,
      intro:
        "Achieve 5–15% Sustainable Reduction in IT Run Costs through Portfolio Simplification and Strategic Modernization. Our IT Cost Optimization service helps organizations unlock significant cost savings from their existing IT landscape without compromising business agility or performance. We apply a proven framework combining portfolio rationalization, standardization, and architecture simplification, tailored to enterprise complexity and industry needs (e.g., healthcare, pharma, medtech).",
      description:
        "Our framework combines bottom-up technical diagnostics with top-down business capability mapping, including: Rapid Portfolio Assessment (2–3 weeks), Optimization Blueprint Development (target-state architecture + roadmap), Business Case & Savings Validation, Execution Support with Change Management.",
      features: [
        {
          title: "Application Portfolio Rationalization",
          details: [
            "Identification and retirement of redundant or underutilized applications",
            "Mapping business capabilities to applications to remove overlaps",
            "Consolidation of tools across departments/functions (e.g., from 4 BI tools to 1 standard)",
            "Rationalization roadmap aligned with contract expiry and support cycles",
          ],
        },
        {
          title: "Technology Heterogeneity Reduction",
          details: [
            "Assessment of platform diversity (e.g., databases, integration layers, analytics stacks)",
            "Migration planning to preferred tech stacks (e.g., cloud-native, open standards)",
            "Elimination of technical debt by phasing out legacy platforms",
          ],
        },
        {
          title: "Standardization & Process Alignment",
          details: [
            "Enforcement of common tools, templates, and platforms across geographies and BUs",
            "Centralization of service management (e.g., one ITSM, one monitoring solution)",
            "Master data unification and governance framework setup",
          ],
        },
        {
          title: "Architecture Simplification",
          details: [
            "Review of integration layers, data flows, and interface redundancies",
            "Recommendation of reusable microservices or APIs",
            "Move from monolith to modular and composable architecture",
          ],
        },
        {
          title: "Cloud & Infra Optimization",
          details: [
            "Right-sizing cloud resources, shutting down idle workloads",
            "Licensing audits and optimization (e.g., SaaS license consolidation)",
            "Introduction of FinOps practices to track cloud spends effectively",
          ],
        },
        {
          title: "Methodology",
          details: [
            "Rapid Portfolio Assessment (2–3 weeks)",
            "Optimization Blueprint Development (target-state architecture + roadmap)",
            "Business Case & Savings Validation",
            "Execution Support with Change Management",
          ],
        },
      ],
    },
    "08": {
      title: "Radiology Workflow Solutions",
      thumb: Image2,
      intro:
        "Optimizing Efficiency, Quality, and Patient Experience Across the Imaging Suite. Radiology departments today face increasing pressure to deliver faster, more accurate diagnostics while balancing resource constraints, growing patient volumes, and digital transformation. Numantra's Radiology Workflow Solutions are designed to empower healthcare providers to streamline end-to-end radiology operations—from scheduling to reporting—by leveraging data, process intelligence, and analytics.",
      description:
        "We help radiology organizations and imaging centers build comprehensive Suite Management Solutions that enable transparency, efficiency, and continuous improvement across the entire patient and procedural journey. Our differentiators include deep healthcare expertise, proven KPI and benchmarking methodologies, custom-built solutions, and outcome-focused engagements.",
      features: [
        {
          title: "Suite Management Platform Design",
          details: [
            "Holistic mapping of the radiology workflow—from Appointment Scheduling, Check-in, Preparation, and Imaging Procedure, to Discharge, Reporting, and Follow-up Communication",
            "Support for multiple clinical models and site-specific variations to ensure global-local alignment",
          ],
        },
        {
          title: "KPI Framework & Benchmarking Tools",
          details: [
            "Development of a radiology-specific KPI library including time, utilization, throughput, wait time, and quality indicators",
            "Comparative benchmarking engine enabling internal and peer-to-peer performance insights",
          ],
        },
        {
          title: "Data Integration & Visualization Dashboards",
          details: [
            "Creation of flexible data models that handle heterogeneous system landscapes and formats",
            "Intuitive dashboards for radiology suite managers to monitor operations, identify bottlenecks, and enable proactive decisions",
          ],
        },
        {
          title: "Process Decomposition & Continuous Improvement",
          details: [
            "Application of LEAN and Six Sigma principles tailored for radiology workflows",
            "Process deep-dives to uncover hidden inefficiencies and opportunities for optimization",
            "Training, enablement, and change management to support long-term value realization",
          ],
        },
        {
          title: "Our Differentiators",
          details: [
            "Healthcare & Radiology Expertise – Dedicated teams with deep domain experience in imaging suite operations",
            "KPI & Benchmarking Methodologies – Proven models for defining, measuring, and comparing radiology performance",
            "Custom-Built Solutions – No one-size-fits-all tools; each solution is tailored to your workflow, data availability, and operational goals",
            "Outcome-Focused Engagements – Designed to deliver measurable impact in terms of cost, capacity, patient experience, and quality of care",
          ],
        },
        {
          title: "Business Outcomes",
          details: [
            "Reduction in patient wait times and throughput inefficiencies",
            "Improved asset and resource utilization across suites",
            "Better case flow predictability and scheduling alignment",
            "Increased transparency and cross-site comparability for multi-location networks",
            "Higher staff satisfaction and productivity via simplified decision support tools",
          ],
        },
      ],
    },
    "09": {
      title: "Pharma Value Chain Analytics",
      thumb: Image3,
      intro:
        "Accelerate Performance Across the Pharma Value Chain with Advanced Analytics. At Numantra, we enable pharmaceutical and life sciences companies to drive data-powered decisions across the entire value chain — from R&D to market access. Our deep domain expertise combined with AI/ML and advanced data engineering empowers your teams to uncover hidden efficiencies, elevate productivity, and optimize investments.",
      description:
        "Our service covers R&D Analytics, Sales & Marketing Effectiveness, Manufacturing Analytics, Inbound Logistics Analytics, Outbound Logistics Analytics, Procurement Analytics, and Financial Analytics.",
      features: [
        {
          title: "R&D Analytics",
          details: [
            "Maximize R&D ROI with Visibility and Predictive Insights",
            "R&D Productivity Dashboards – Track pipeline efficiency, resource allocation, and output quality",
            "NPV Models for NCEs – Prioritize high-value drug candidates based on modeled commercial value and risks",
            "Portfolio analytics for early-stage vs late-stage trade-offs",
          ],
        },
        {
          title: "Sales & Marketing Effectiveness (SFE)",
          details: [
            "Optimize Sales Force Efficiency and Market Outreach",
            "Competitive Benchmarking – Assess performance vs peers in key therapeutic areas",
            "Sales Rep Productivity Analysis – Performance by geography, rep, brand, and call type",
            "Marketing ROI – Analyze cost vs response across campaigns and channels",
            "Segmentation & targeting intelligence",
          ],
        },
        {
          title: "Manufacturing Analytics",
          details: [
            "Improve Plant Efficiency and Cost Control",
            "Actual Cost Sheets – Batch-wise, SKU-level cost build-up including API, utilities, labor",
            "Cycle Time and Throughput Analysis – Stage-wise breakdown for delay detection",
            "Yield & Efficiency Dashboards – Visualize bottlenecks and waste",
            "Variance analysis (planned vs actual, yield loss, scrap)",
          ],
        },
        {
          title: "Inbound Logistics Analytics",
          details: [
            "Enhance Raw Material Supply Chain Resilience",
            "Inventory Monitors (RM/PM) – Real-time FSN classification and aging",
            "Vendor Lead Time & SLA Analysis – Identify delays and procurement risks",
            "Safety stock and reorder-level recommendations",
          ],
        },
        {
          title: "Outbound Logistics Analytics",
          details: [
            "Ensure Timely and Safe Product Deliveries",
            "Expiration Alerts – Risk-based monitoring of near-expiry stock across locations",
            "Order Fulfillment (OTIF) Analysis – Root cause deep dives for misses",
            "Cold chain and compliance tracking where applicable",
          ],
        },
        {
          title: "Procurement Analytics",
          details: [
            "Drive Strategic Sourcing and Cost Savings",
            "Spend Optimization – Category-wise and SKU-level insights for consolidation",
            "Vendor Price/Performance Dashboards – Track quality, reliability, and cost dynamics",
            "Payables & aging analysis for working capital improvement",
          ],
        },
        {
          title: "Financial Analytics",
          details: [
            "Enable Profitability and Strategic Clarity",
            "Product / Brand Profitability – Multi-dimensional profitability by brand, therapy, region",
            "Cash-to-Cash Cycle Analysis – Optimize liquidity and capital flows",
            "Executive Scorecards – Growth, achievement, and risk metrics for leadership",
            "Legal and management-level consolidation of financial performance",
          ],
        },
      ],
    },
    10: {
      title: "Digital Strategy",
      thumb: Image4,
      intro:
        "Empowering Pharma and MedTech Companies to Compete in a Digital-First Future. In today's rapidly evolving healthcare ecosystem, pharma and medtech companies are under pressure to transform digitally—aligning global ambitions with local execution, rationalizing IT complexity, and building scalable digital solutions. At Numantra, we help organizations reimagine their digital strategy with a clear, pragmatic, and outcome-driven approach.",
      description:
        "Our approach includes Strategic Alignment and Capability Realignment at Scale, covering Strategy Cascade & Solution Visioning, IT & Capability Transparency, Capability Model & Gap Analysis, Portfolio Rationalization & Operating Model Design, and Typical Outcome & Impact.",
      features: [
        {
          title: "Strategy Cascade & Solution Visioning",
          details: [
            "Translate global business strategies into actionable digital priorities and success factors",
            'Define what "winning in the solutions space" means—clarifying required business, tech, and data enablers',
          ],
        },
        {
          title: "IT & Capability Transparency",
          details: [
            "Build a comprehensive factbase of all your IT systems: purpose, usage, business value, ownership, and roadmap",
            "Create full transparency to guide consolidation, rationalization, and investment",
          ],
        },
        {
          title: "Capability Model & Gap Analysis",
          details: [
            "Develope a Global Digital Capability Framework with an outline of future-state maturity requirements",
            "Identify gaps across geographies and proposed sequencing of capability uplift",
          ],
        },
        {
          title: "Portfolio Rationalization & Operating Model Design",
          details: [
            "Provided portfolio-level recommendations to trim redundancies and align to the new target model",
            "Designed a standardized global operating model with localized rollout archetypes for agility",
          ],
        },
        {
          title: "Typical Outcome & Impact",
          details: [
            "25-35% Reduction in Global IT Heterogeneity",
            "2-3X Capability Coverage per System – reduced tech sprawl, increased functionality per investment",
            "Harmonized Operating Model with strategic flexibility for country-specific execution",
            "Establishment of a Global Capability Platform that guides investment, prioritization, and AI-ML enablement",
            "Foundation for scalable and high-impact digital solution delivery",
          ],
        },
      ],
    },
    11: {
      title: "Customer Centricity Solutions",
      thumb: Image5,
      intro:
        "Putting your customers at the heart of your business. At NumantraTech, we believe true growth comes from a relentless focus on your customers. Our Customer Centricity (CC) solutions take you from vision to execution — integrating strategy, technology, and AI to build an organisation where every decision, process, and interaction revolves around customer value.",
      description:
        "We guide you end-to-end, from defining a customer-centric vision to deploying AI-powered, future-ready systems.",
      features: [
        {
          title: "Strategy – Defining the Vision & Roadmap",
          details: [
            "We start by helping you set a clear Customer Centricity vision and align it with your business objectives",
            "Future-ready operating model tailored around customers",
            "Embedding a customer-first mindset into your business model",
            "Building a multi-year roadmap with a bundle of strategic initiatives to ensure progress and measurable results year over year",
            "Our strategic work ensures that customer centricity is not a slogan — it's a business reality",
          ],
        },
        {
          title: "CRM & Technology Enablement",
          details: [
            "Once the strategy is in place, we turn vision into capability through robust CRM enablement",
            "Define functional specifications across your commercial chain",
            "Design around a centralised Customer Data Platform (CDP) for a 360° view of each customer",
            "Implement leading CRM platforms — Salesforce (SFDC), SAP CRM, or a bespoke solution via our proprietary HCare platform",
            "Our approach ensures fast turnaround times, lower total cost of ownership, optimised cost structures with agile, adaptable elements in your technology landscape, and next-in-class operations that are future-proof and scalable",
          ],
        },
        {
          title: "AI Solutions – Intelligence at Every Touchpoint",
          details: [
            "We deploy AI capabilities that anticipate customer needs and enhance every interaction",
            "Propensity models to identify the right customers and predict conversion potential",
            "AI workflow agents to streamline and automate commercial processes",
            "Social listening tools to capture and act on customer sentiment in real-time",
            "Deep insights on behaviour, patterns, and preferences to personalise offers and experiences",
            "The result? Customers feel understood, valued, and engaged — across every channel and touchpoint",
          ],
        },
        {
          title: "Industries We Serve",
          details: [
            "Real Estate – Personalised customer journeys and sales automation",
            "Engineering – Account-based engagement for complex B2B cycles",
            "Healthcare & MedTech – Patient-centric engagement and compliance-aligned communication",
            "Retail – Omnichannel experiences powered by real-time insights",
          ],
        },
        {
          title: "Why NumantraTech?",
          details: [
            "End-to-end coverage: Strategy → CRM enablement → AI deployment",
            "Proprietary accelerators like HCare for faster, lower-cost delivery",
            "Industry-specific expertise for targeted, effective solutions",
            "Future-ready architecture that adapts as your customers and markets evolve",
            "Let's build your customer-centric future",
          ],
        },
      ],
    },
  };

  /**
   * Agency project section
   */

  const projectList = [
    {
      image: Image6,
      title: "HCare360 Data Platform",
      subtext:
        "Unlock the full power of your data with our cloud-native, next-generation data platform designed for healthcare and life sciences organizations.",
      details: [
        "Secure and compliant architecture (HIPAA, GDPR)",
        "ML-powered data quality management",
        "Built-in AI/ML toolbox and self-service analytics",
        "Unified data governance and metadata management",
      ],
      serviceKey: "06",
    },
    {
      image: Image1,
      title: "IT Cost Optimization",
      subtext:
        "Get 5-15% reduction in your IT run costs with our proven framework on IT portfolio optimization by reducing heterogeneity and redundant applications",
      details: [
        "Reduce IT run costs by 5-15%",
        "Proven framework for IT portfolio optimization",
        "Reduce heterogeneity and redundant applications",
      ],
      serviceKey: "07",
    },
    {
      image: Image2,
      title: "Radiology Workflow Solutions",
      subtext:
        "Streamline your workflows from scheduling to exploration to diagnosis and reporting/ communication utilizing powerful AI models",
      details: [
        "AI-powered workflow streamlining",
        "Covers scheduling, diagnosis, reporting, communication",
      ],
      serviceKey: "08",
    },
    {
      image: Image3,
      title: "Pharma Value Chain Analytics",
      subtext:
        "Streamline your pharmaceutical supply chain for improved visibility, reduced costs, and enhanced regulatory compliance.",
      details: [
        "Improved supply chain visibility",
        "Reduced costs",
        "Enhanced regulatory compliance",
      ],
      serviceKey: "09",
    },
    {
      image: Image4,
      title: "Digital Strategy",
      subtext:
        "Numantra's digital strategies create actionable roadmaps to create new revenue streams from data assets and embed data into a future-ready operating model.",
      details: [
        "Actionable digital roadmaps",
        "Create new revenue streams from data assets",
        "Embed data into a future-ready operating model",
      ],
      serviceKey: "10",
    },
    {
      image: Image5,
      title: "Customer Centricity Solutions",
      subtext:
        "Putting your customers at the heart of your business with end-to-end solutions from strategy to AI deployment.",
      details: [
        "Strategy & roadmap development",
        "CRM & technology enablement",
        "AI-powered customer insights",
      ],
      serviceKey: "11",
    },
  ];

  const handleCardClick = (item) => {
    // Check if detailed service data exists for this item
    const detailedService = serviceData[item.serviceKey];

    if (detailedService) {
      // Use detailed service data
      setModalData({
        title: detailedService.title,
        image: detailedService.thumb,
        sections: [
          { heading: "Introduction", content: detailedService.intro },
          { heading: "Description", content: detailedService.description },
          ...detailedService.features.map((feature) => ({
            heading: feature.title,
            content: feature.details,
          })),
        ],
      });
    } else {
      // Fallback to original simple data
      setModalData({
        title: item.title,
        image: item.image,
        sections: [
          { heading: item.title, content: item.subtext },
          { heading: "Details", content: item.details },
        ],
      });
    }
    setModalOpen(true);
  };

  return (
    <>
      {/* Project Start  */}
      <section className="section" id="project">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Our Solutions</h4>
                <p className="text-muted mx-auto para-desc mb-0">
                  Get your data capabilities right-the-first-time!
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            {projectList.map((item, index) => (
              <Col lg={4} md={6} className="col-12 mt-4 pt-2" key={index}>
                <Card
                  className="border-0 project project-primary position-relative d-block overflow-hidden rounded"
                  onClick={() => handleCardClick(item)}
                  style={{ cursor: "pointer" }}
                >
                  <CardBody className="p-0">
                    <img
                      src={item.image}
                      className="img-fluid"
                      alt="workimage"
                    />
                    <div className="overlay-work bg-dark"></div>
                    <div className="content">
                      <h6 className="mb-0">
                        <span className="text-white title">{item.title}</span>
                      </h6>
                      <p className="text-light tag mb-0 text-xs">
                        {item.subtext}
                      </p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
          <>
            {isOpen && (
              <Lightbox
                mainSrc={images[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={
                  images[(photoIndex + images.length - 1) % images.length]
                }
                onCloseRequest={() => setIsOpen(false)}
                onMovePrevRequest={() =>
                  setPhotoIndex(
                    (photoIndex + images.length - 1) % images.length
                  )
                }
                onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % images.length)
                }
              />
            )}
          </>
        </Container>
      </section>
      <DetailsModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        {...modalData}
      />
      {/* Project End  */}
    </>
  );
}
